import { render, staticRenderFns } from "./todosPop.vue?vue&type=template&id=7353a145"
import script from "./todosPop.vue?vue&type=script&lang=js"
export * from "./todosPop.vue?vue&type=script&lang=js"
import style0 from "./todosPop.vue?vue&type=style&index=0&id=7353a145&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports